<div *ngFor="let item of details" class="detail">
  {{ item }}
</div>